import React, { useEffect, useState } from "react";
import Modal from "@components/modal";
import { isWebView } from "@utils/commonUtils";
import { getInrFormat } from "@utils/inrFormatter";

const SESSION_KEY = "pseudo_coupon_winback_modal_shown";

interface Props {
  isPseudo?: boolean;
  code?: string;
  value?: number | string;
  lockBackgroundInteraction?: boolean;
}

const PseudoCouponModal = ({
  isPseudo,
  code,
  value,
  lockBackgroundInteraction = true
}: Props) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!isPseudo || !code || !Number(value) || !isWebView()) return;
    if (sessionStorage.getItem(SESSION_KEY) === "true") return;

    let closeTimer: number | undefined;
    const openTimer = window.setTimeout(() => {
      sessionStorage.setItem(SESSION_KEY, "true");
      setShowModal(true);
      closeTimer = window.setTimeout(() => setShowModal(false), 3000);
    }, 750);

    return () => {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      setShowModal(false);
    };
  }, [code, isPseudo, value]);

  if (!isPseudo) return null;

  return (
    <Modal
      showModal={showModal}
      setShowModal={setShowModal}
      hideCloseButton
      actions={{}}
      lockBackgroundInteraction={lockBackgroundInteraction}
    >
      <div style={{ textAlign: "center", padding: "12px 0 20px" }}>
        <div style={{ color: "#0FA457", fontSize: "28px", fontWeight: 700 }}>
          Flat ₹{getInrFormat(Number(value))} OFF
        </div>
        <div style={{ fontSize: "16px", marginTop: "8px" }}>
          applied on selected plans
        </div>
        <div style={{ fontSize: "14px", fontWeight: 600, marginTop: "20px" }}>
          &apos;{code}&apos; coupon redeemed
        </div>
      </div>
    </Modal>
  );
};

export default PseudoCouponModal;
